<template>
    <div class="card mt-2">
        <div class="card-header d-flex justify-content-between align-items-start">
            <h5 class="card-title">{{ title }}</h5>
            <button :id="'add' + title.replaceAll(' ','') + 'Button'" type="button" class="btn btn-outline-secondary" v-on:click="addClientBranch">Add</button>
        </div>
        <ul class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between align-items-start" v-for="clientBranch in currentBranches" :key="clientBranch.id">
                <input type="hidden" v-bind:name="serializedValueName" v-bind:value="clientBranch.serialized" />
                <div class="p-0 m-0 flex-grow-1">
                    <div>{{ clientBranch.name }}</div>
                </div>
                <div class="btn-group" role="group" aria-label="Action buttons">
                    <button type="button" class="btn btn-outline-secondary" v-on:click="editClientBranch(clientBranch)">Edit</button>
                    <button type="button" class="btn btn-outline-secondary" v-on:click="removeClientBranch(clientBranch)">Remove</button>
                </div>
            </li>
        </ul>
        <validation-observer v-slot="{ passes }" slim>
            <b-modal id="clientBranchEditDialog"
                     size="md"
                     centered
                     v-model="clientBranchEditDialogShown"
                     v-bind:title="detailsDialogTitle"
                     v-on:ok.prevent="passes(createOrUpdateClientBranch)">
                <b-alert v-model="showErrors" variant="danger" dismissible>
                    <div v-for="(error, index) in currentErrors" :key="index">
                        <p>{{ error }}</p>
                    </div>
                </b-alert>
                <b-form-row>
                    <validation-provider rules="required" name="Name" v-slot="{ valid, errors }" slim>
                        <b-form-group label="Name"
                                      label-for="clientBranchName"
                                      class="col-md-12">
                            <b-form-input name="clientBranchName"
                                          autofocus
                                          v-model="currentClientBranch.name"
                                          :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('email', email);
    localize('en', en);

    import Select2 from './Select2';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    
    Vue.use(BootstrapVue);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.component('select2', Select2);

    export default {
        name: 'ClientBranches',
        mixins: [ErrorsMixin],
        props: {
            title: {
                type: String,
                default: 'Client Branches'
            },
            serializedValueName: {
                type: String,
                required: true
            },
            branches: {
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                currentBranches: this.branches,
                clientBranchEditDialogShown: false,
                currentClientBranch: { id: null, name: null },
                currentErrors: [],
            }
        },
        computed: {
            detailsDialogTitle: function () {
                return 'Branch Details';
            },
            showErrors: function () {
                return this.currentErrors.length > 0;
            }
        },
        methods: {
            addClientBranch: function () {
                this.currentClientBranch = { id: null, name: null };
                this.currentErrors = [];
                this.clientBranchEditDialogShown = true;
            },
            editClientBranch: function (clientBranch) {
                this.currentClientBranch = JSON.parse(JSON.stringify(clientBranch));
                this.currentErrors = [];
                this.clientBranchEditDialogShown = true;
            },
            removeClientBranch: function (clientBranch) {
                var clientBranchIndex = this.currentBranches.indexOf(clientBranch);

                if (this.currentBranches.length == 1) {
                    this.currentErrors = [];
                    this.currentErrors.push("Cannot remove client branch.  At least 1 branch is required.");
                    this.showErrorsToast(this.currentErrors);
                    return;
                }

                this.currentBranches.splice(clientBranchIndex, 1);
            },
            createOrUpdateClientBranch: function () {
                var data = {
                    serializedClientBranches: [],
                    clientBranch: this.currentClientBranch
                }
                this.currentErrors = [];
                this.currentBranches.forEach(cc => data.serializedClientBranches.push(cc.serialized));
                console.log(JSON.stringify(data));
                axios
                    .post(this.$urlHelper.getApiUrl('clientbranch', 'offline'), JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        this.currentBranches = response.data
                    })
                    .catch(ex => {
                        this.currentErrors = this.handleAxiosException(ex);
                    })
                    .finally(() => {
                        if (this.currentErrors.length == 0) {
                            this.clientBranchEditDialogShown = false;
                        }
                    })
            }
        }
    }
</script>